export const formatRoles = (data) => {
  if (data === 'master') return 'Super Admin';
  if (data === 'admin') return 'Administrador';
  if (data === 'user') return 'Usuário';
  if (data === 'inspector') return 'Vistoriador';
  if (data === 'api') return 'API';
};
